var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortAsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2513_18107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08875 7.37109H6.91125C7.43479 7.37109 7.69655 8.14631 7.32714 8.59827L4.41589 12.1601C4.18593 12.4414 3.81407 12.4414 3.58655 12.1601L0.672857 8.59827C0.303446 8.14631 0.565214 7.37109 1.08875 7.37109Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32714 4.14392L4.41589 0.582108C4.18593 0.300756 3.81407 0.300756 3.58655 0.582108L0.672857 4.14392C0.303446 4.59588 0.565214 5.37109 1.08875 5.37109H6.91125C7.43479 5.37109 7.69655 4.59588 7.32714 4.14392Z",
    fill: "#CF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2513_18107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.371094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort-asc.f1080a8930e4f79eec6686507592c552.svg";
export { ForwardRef as ReactComponent };